import React from "react";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation } from "react-router-dom";
import { isAmppa } from "../../utils/isAmppa";

import "./AuthHome.css";
import addSuperScript from "../../utils/superscript";

export default function AuthHome(): JSX.Element {

    const { t } = useTranslation('login');
    const location = useLocation();

    const isRegPath = location.pathname.includes("reg-user");

    return (
        <>
            <div className="auth-home-top-content">
                <span><h1>
                    {addSuperScript(t("welcome"))}
                </h1></span>
                <p>{addSuperScript(t("welcome-top1") as string)}</p>
                {/* <p>{t("welcome-top2") as string}</p> */}
                <br/>
                <br/>
                <div className="auth-home-nav-parent">
                    {
                        isAmppa ?
                            (
                                <>
                                    <div className={("auth-home-nav ") + (!isRegPath ? "active" : "")}>
                                        <Link className="amp-anchor" to="/auth/home">{t("sign-in")}</Link>
                                    </div>
                                </>
                            )
                            :
                            (
                                <>
                                    <div className={("auth-home-nav ") + (!isRegPath ? "active" : "")}>
                                        <Link className="amp-anchor" to="/auth/home">{t("new-user") as string}</Link>
                                    </div>
                                    <div className={("auth-home-nav ") + (isRegPath ? "active" : "")}>
                                        <Link className="amp-anchor" to="/auth/home/reg-user">{t("reg-user") as string}</Link>
                                    </div>
                                </>
                            )
                    }

                </div>
            </div>
            <Outlet />
            <div className="light-blue-bar span-page-blue-bar"></div>
        </>
    )
}